/** أدواتُ حقل التاريخ بقوائم (`DateParts`) — مفصولةٌ عن المكوّن ليُختبر حسابُها وحده */
export type DatePartsKind = 'date' | 'datetime-local' | 'month';

export const MONTHS_AR = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

export interface Parts { y: string; m: string; d: string; h: string; mi: string }
export const EMPTY: Parts = { y: '', m: '', d: '', h: '', mi: '' };
export const pad = (n: number | string) => String(n).padStart(2, '0');

export function parseParts(kind: DatePartsKind, value: string | undefined | null): Parts {
  const v = (value ?? '').trim();
  const m = /^(\d{4})-(\d{2})(?:-(\d{2}))?(?:T(\d{2}):(\d{2}))?/.exec(v);
  if (!m) return { ...EMPTY };
  return { y: m[1], m: m[2], d: kind === 'month' ? '' : (m[3] ?? ''), h: kind === 'datetime-local' ? (m[4] ?? '') : '', mi: kind === 'datetime-local' ? (m[5] ?? '') : '' };
}

export function daysIn(y: string, m: string): number {
  if (!m) return 31;
  const year = y ? Number(y) : 2000; // سنةٌ كبيسة حين لا تُعرف — لا يُحذف ٢٩ فبراير قبل اختيار السنة
  return new Date(Date.UTC(year, Number(m), 0)).getUTCDate();
}

/** القيمةُ الكاملة أو '' — لا قيمةَ نصفية تخرج من الحقل */
export function composeParts(kind: DatePartsKind, p: Parts): string {
  if (!p.y || !p.m) return '';
  if (kind === 'month') return `${p.y}-${p.m}`;
  if (!p.d) return '';
  const date = `${p.y}-${p.m}-${p.d}`;
  if (kind === 'date') return date;
  if (!p.h || !p.mi) return '';
  return `${date}T${p.h}:${p.mi}`;
}

